import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { SettingsProvider } from './contexts/SettingsContext'
import { AuthProvider } from './contexts/AuthContext'
import { APIKeyProvider } from './contexts/APIKeyContext'
import Header from './components/Header'
import Footer from './components/Footer'
import GradingInterface from './components/GradingInterface'
import LoginPage from './components/LoginPage'
import ProtectedRoute from './components/ProtectedRoute'
import Settings from './Settings'
import Contact from './Contact'
import Privacy from './Privacy'
import Terms from './Terms'
import CookiePolicy from './CookiePolicy'
import ApiReference from './ApiReference'
import Tutorials from './Tutorials'
import './App.css'

function App() {
  // Initialize theme on app load
  useEffect(() => {
    // Default to dark mode if no theme is saved
    const savedTheme = localStorage.getItem('ai-grading-agent-theme');
    if (savedTheme === 'dark' || !savedTheme) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  return (
    <AuthProvider>
      <SettingsProvider>
        <APIKeyProvider>
          <Router>
            <Routes>
              {/* Public route - Login page */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected routes - All app content */}
              <Route path="/*" element={
                <ProtectedRoute>
                  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
                    <Header />
                    <main className="flex-1">
                      <Routes>
                        <Route path="/" element={<GradingInterface />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="/api-reference" element={<ApiReference />} />
                        <Route path="/tutorials" element={<Tutorials />} />
                      </Routes>
                    </main>
                    <Footer />
                  </div>
                </ProtectedRoute>
              } />
            </Routes>
          </Router>
        </APIKeyProvider>
      </SettingsProvider>
    </AuthProvider>
  )
}

export default App
